import { Platform } from "../platforms/platform";

export enum VK_KEYS {
  VK_REWIND = 412,
  VK_FAST_FWD = 417,
  VK_TRACK_NEXT = 425,
  VK_TRACK_PREV = 463,
  VK_PLAY = 415,
  VK_PAUSE = 19,
  VK_STOP = 413,
  VK_INFO = 457,
}

export class KeyCodes {
  static KEY_OK = 13;
  static KEY_LONG_OK = 1313;
  static KEY_LEFT = 37;
  static KEY_RIGHT = 39;
  static KEY_UP = 38;
  static KEY_DOWN = 40;
  static KEY_BACK = 8;
  static KEY_BACKSPACE = 8;
  static KEY_REWIND = VK_KEYS.VK_REWIND;
  static KEY_FORWARD = VK_KEYS.VK_FAST_FWD;
  static KEY_NEXT = VK_KEYS.VK_TRACK_NEXT;
  static KEY_PREVIOUS = VK_KEYS.VK_TRACK_PREV;
  static KEY_PLAYPAUSE = 179;
  static KEY_PLAY = VK_KEYS.VK_PLAY;
  static KEY_PAUSE = VK_KEYS.VK_PAUSE;
  static KEY_EXIT = 27;
  static KEY_STOP = VK_KEYS.VK_STOP;
  static KEY_INFO = VK_KEYS.VK_INFO;
  static KEY_RED = 403;
  static KEY_GREEN = 404;
  static KEY_YELLOW = 405;
  static KEY_BLUE = 406;
  static KEY_HOME = 77;
}
